import React from 'react';
import { Container, Spinner, Row, Col, Button } from 'react-bootstrap';
import { withAuthorization } from '../Session';
import RestServices from '../services/RestServices.js';

import DateFnsUtils from '@date-io/date-fns';

import { dateFormatUtil } from '../Utilities';

class Migrations extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            alert: 0,
            alertMessage: '',
            data: [],
            flag: false,
            isTableReady: false,
            showAddEdit: false,
            showDetails: false,
            selectedRow: [],
            StoreCPCount: 0,
            StoreOwnerCount: 0,
            MappingHCount: 0,
            AllProfilesCounts: 0
        };
    }

    async componentDidMount() {
        this._isMounted = true;
    }

    UpdateMappingHistory = async () => {
        if (this._isMounted) {
            this.setState({ flag: true });
        }
        await RestServices.exportMappingHistory(
            localStorage.getItem('FirebaseToken')
        )
            .then((response) => response.json())
            .then(async (data) => {
                if (this._isMounted) {
                    this.setState({ MappingHCount: data.length });
                }
                await data.forEach(async (bodyData) => {
                    var postData = {
                        StoreTag: bodyData.StoreTag,
                        UpdatedBy: bodyData.UpdatedBy,
                        LastUpdatedTimeStamp: bodyData.LastUpdatedTimeStamp,

                        StoreCP: bodyData.StoreCP,
                        StoreCPName: bodyData.StoreCPName,
                        StoreCPWhatsAppNumber: bodyData.StoreCPWhatsAppNumber,

                        StoreOwner: bodyData.StoreOwner,
                        StoreOwnerName: bodyData.StoreOwnerName,
                        StoreOwnerWhatsAppNumber:
                            bodyData.StoreOwnerWhatsAppNumber
                    };

                    try {
                        await RestServices.updateMappingHistory(
                            localStorage.getItem('FirebaseToken'),
                            postData
                        )
                            .then((response) => response.json())
                            .then(async (responsedata) => {
                                
                            });
                    } catch (error) {
                        
                    }
                });
                if (this._isMounted) {
                    this.setState({ flag: false });
                }
            })
            .catch((err) => {});
    };

    syncStoreCP = async () => {
        if (this._isMounted) {
            this.setState({ flag: true });
        }
        await RestServices.exportChannelPartnerDoc(
            localStorage.getItem('FirebaseToken')
        )
            .then((response) => response.json())
            .then(async (data) => {
                if (this._isMounted) {
                    this.setState({ StoreCPCount: data.length });
                }
                await data.forEach(async (bodyData) => {
                    bodyData['RequestedTimeStamp'] = dateFormatUtil();
                    bodyData['UpdatedBy'] = this.props.user.FullName;

                    await RestServices.importStoreCP(
                        localStorage.getItem('FirebaseToken'),
                        bodyData
                    )
                        .then((response) => response.json())
                        .then(async (responsedata) => {
                            
                        });
                });
                if (this._isMounted) {
                    this.setState({ flag: false });
                }
            })
            .catch((err) => {});
    };

    syncStoreOwner = async () => {
        if (this._isMounted) {
            this.setState({ flag: true });
        }
        await RestServices.exportStoreOwnerDoc(
            localStorage.getItem('FirebaseToken')
        )
            .then((response) => response.json())
            .then(async (data) => {
                if (this._isMounted) {
                    this.setState({ StoreOwnerCount: data.length });
                }
                await data.forEach(async (bodyData) => {
                    bodyData['RequestedTimeStamp'] = dateFormatUtil();
                    bodyData['UpdatedBy'] = this.props.user.FullName;
                    
                    await RestServices.importStoreOwners(
                        localStorage.getItem('FirebaseToken'),
                        bodyData
                    )
                        .then((response) => response.json())
                        .then(async (responsedata) => {
                            
                        });
                });
                if (this._isMounted) {
                    this.setState({ flag: false });
                }
            })
            .catch((err) => {});
    };

    syncAllProfiles = async () => {
        if (this._isMounted) {
            this.setState({ flag: true });
        }
        await RestServices.syncAllProfiles(
            localStorage.getItem('FirebaseToken')
        )
            .then((response) => response.json())
            .then(async (data) => {
                
                if (this._isMounted) {
                    this.setState({
                        flag: false,
                        AllProfilesCounts: data.length
                    });
                }
            })
            .catch((err) => {});
    };

    render() {
        return (
            <Container>
                {this.state.flag && <Spinner animation="border" />}
                <Row>
                    <h4 style={{ marginLeft: '1rem', marginRight: '1rem' }}>
                        Manage Migrations
                    </h4>
                </Row>
                <div>
                    <hr />
                </div>

                <Row>
                    <Col>
                        <Button variant="info" onClick={this.syncAllProfiles}>
                            Migrate All Profiles
                        </Button>
                        {this.state.AllProfilesCounts > 0 && (
                            <p>{this.state.StoreCPCount} Migrated</p>
                        )}
                    </Col>

                    <Col>
                        <Button variant="info" onClick={this.syncStoreCP}>
                            Migrate StoreCP
                        </Button>
                        {this.state.StoreCPCount > 0 && (
                            <p>{this.state.StoreCPCount} Migrated</p>
                        )}
                    </Col>

                    <Col>
                        <Button variant="info" onClick={this.syncStoreOwner}>
                            Migrate StoreOwner
                        </Button>
                        {this.state.StoreOwnerCount > 0 && (
                            <p>{this.state.StoreOwnerCount} Migrated</p>
                        )}
                    </Col>

                    <Col>
                        <Button
                            variant="info"
                            onClick={this.UpdateMappingHistory}
                        >
                            Re-Set Mapping History
                        </Button>
                        {this.state.MappingHCount > 0 && (
                            <p>{this.state.MappingHCount} Updated</p>
                        )}
                    </Col>
                </Row>
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(Migrations);
